import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Address from '../../entities/address';
export function deleteAddress(address: Address, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = address.id;}
const _work = workingSet();




address.status = 'D';
address.addedOn = newHRTimestamp();
address.addedBy = getCurrentUserId();
address.importSource = targetImportSource;
address.importId = mergeId;
store.dispatch(Actions.AddressActions.removeAddressQueue(address));
}


